import MainTemplate from "../MainTemplate.js";
import MyRewardsLeftSide from "./fragments/MyRewardsLeftSide.js";
import { useDispatch, useSelect } from "react-redux";
import MyRewardsCupons from "./fragments/MyRewardsCupons.js";
import MyRewardsTiers from "./fragments/MyRewardsTiers.js";
import pogodnosti_statusa from "../../../assets/pogodnosti_statusa.svg";
import kuponi from "../../../assets/kuponi.svg";
import { useState, useMemo, useEffect } from "react";
import { asyncActions as asyncUserActions } from "../../../store/slices/userSlice.js";

const MainPage = () => {

  


  //////////////////////////////////////////////dispatcher
  const dispatch = useDispatch();
  ///////////////////////////////////////////////get tiers

  

  const [selectedRegion, setSelectedRegion] = useState("cuponRewards");



  let rewardRegions = [
    {
      name: "cuponRewards",
      icon: kuponi,
      component: (props) => <MyRewardsCupons {...props} />,
      getters : [asyncUserActions.getUserInfo]
    },
    {
      name: "tierRewards",
      icon: pogodnosti_statusa,
      component: (props) => <MyRewardsTiers {...props} />,
      getters : [asyncUserActions.getUserInfo]
    },
  ];

  rewardRegions = rewardRegions.map((region) => {
    return { ...region, isSelected: region.name === selectedRegion };
  });

  const selectedRewardRegion = rewardRegions.find(
    (region) => region.isSelected === true
  );
  const selectedRewardRegionName = selectedRewardRegion.name;


  useEffect(() => {
    let promises = [];
    const currentDispatchers = selectedRewardRegion?.getters ?? [];
    currentDispatchers.forEach((dispatcher) => {
      const promise = dispatch(dispatcher());
      promises.push(promise);
    });

    return () => {
      promises.forEach(promise => {
        if (promise) {
          promise.abort();
        }
      });
    };
  }, [selectedRewardRegionName]);



  const SelectedComponent = useMemo(() => {
    return (props) => <selectedRewardRegion.component {...props} />;
  }, [selectedRewardRegionName]);

  return (
    <MainTemplate
      title="myRewards"
      showBadge
      LeftSideComponent={() => (
        <MyRewardsLeftSide
          selectedRegion={selectedRegion}
          setSelectedRegion={setSelectedRegion}
          rewardRegions={rewardRegions}
        />
      )}
      MainComponent={SelectedComponent}
      image={{ src: "reward_icon" }}
      getUserInfo={false}
      getTierInfo={false}
    />
  );
};

export default MainPage;
